import { render, staticRenderFns } from "./MaintenanceDashboard.vue?vue&type=template&id=474c0c82&scoped=true"
import script from "./MaintenanceDashboard.ts?vue&type=script&lang=ts&external"
export * from "./MaintenanceDashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./MaintenanceDashboard.vue?vue&type=style&index=0&id=474c0c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c0c82",
  null
  
)

export default component.exports